export default __webpack_public_path__ + "static/media/fairy.60171975.gif";